import React from 'react';
import { Check, ArrowRight } from 'lucide-react';
import { trackMetaEvent, getCheckoutUrlWithFbclid } from '../hooks/useMetaPixel';
const CHECKOUT_URL = 'https://dolaresenarg.shop/cart/45155071655983:1';
export function Hero() {
  return <section className="relative pt-20 pb-16 md:pt-28 md:pb-20 overflow-hidden min-h-screen flex items-center" data-id="element-54">
      {/* Floating Background Shapes */}
      <div className="absolute top-10 right-10 w-64 h-64 bg-[#00d4ff] rounded-full mix-blend-screen filter blur-[100px] opacity-30 animate-float pointer-events-none" data-id="element-55"></div>
      <div className="absolute bottom-10 left-10 w-72 h-72 bg-[#ff006e] rounded-full mix-blend-screen filter blur-[120px] opacity-20 animate-float-delayed pointer-events-none" data-id="element-56"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-57">
        <div className="max-w-[900px] mx-auto text-center animate-fade-in-up" data-id="element-58">
          {/* Banner Urgencia */}
          <div className="inline-block bg-gradient-to-r from-[#ff006e] to-[#ff0052] text-white font-bold text-lg px-6 py-2 rounded-full mb-8 animate-pulse-magenta shadow-[0_0_20px_rgba(255,0,110,0.5)]" data-id="element-59">
            ⚡ OFERTA ESPECIAL DE HOY: $14.990 ARS (DESCUENTO -50%)
          </div>

          {/* Titular Principal */}
          <h1 className="text-5xl md:text-6xl lg:text-[4rem] font-black uppercase tracking-[-2px] leading-tight mb-6" data-id="element-60">
            <span className="text-white" data-id="element-61">Generé</span>
            <br data-id="element-62" />
            <span className="text-gradient-cyan-magenta" data-id="element-63">$4.000.000 ARS</span>
            <br data-id="element-64" />
            <span className="text-white" data-id="element-65">en 1 Mes</span>
          </h1>

          {/* Subtítulo */}
          <p className="text-xl md:text-2xl font-light text-[#e0e0e0] mb-10 max-w-3xl mx-auto leading-relaxed" data-id="element-66">
            Aquí está EXACTAMENTE cómo. Sin videos caros. Sin gurús de
            $750.000/mes. Solo sistemas que funcionan. Y ahora tú también
            puedes.
          </p>

          {/* Promise Box */}
          <div className="border-2 border-[#00d4ff] rounded-xl bg-[#00d4ff]/10 p-6 md:p-8 mb-10 max-w-2xl mx-auto text-left" data-id="element-67">
            <ul className="space-y-4" data-id="element-68">
              {['Sin trabajar 8 horas diarias', 'Sin invertir $7.500.000 al inicio', "Sin ser 'influencer' ni tener followers"].map((item, i) => <li key={i} className="flex items-center gap-3 text-lg md:text-xl font-bold text-[#00d4ff]" data-id="element-69">
                  <div className="bg-[#00d4ff]/20 rounded-full p-1" data-id="element-70">
                    <Check className="w-5 h-5 text-[#00d4ff]" data-id="element-71" />
                  </div>
                  {item}
                </li>)}
            </ul>
          </div>

          {/* Pricing */}
          <div className="flex flex-wrap justify-center items-center gap-6 mb-8" data-id="element-72">
            <div className="text-xl text-[#888] font-medium" data-id="element-73">
              Precio Normal:{' '}
              <span className="line-through text-red-500" data-id="element-74">$340.000 ARS</span>
            </div>
            <div className="text-3xl md:text-4xl font-bold text-[#00ff88]" data-id="element-75">
              HOY SOLO: $14.990 ARS
            </div>
          </div>

          {/* CTA Button */}
          <a href={getCheckoutUrlWithFbclid(CHECKOUT_URL)} onClick={() => trackMetaEvent('InitiateCheckout')} className="inline-flex items-center justify-center gap-3 w-full max-w-[500px] bg-gradient-cyan-magenta text-[#1a1a2e] font-black text-xl uppercase tracking-[1px] py-5 px-10 rounded-lg shadow-[0_10px_40px_rgba(0,212,255,0.3)] hover:shadow-[0_20px_60px_rgba(0,212,255,0.5)] hover:-translate-y-[3px] transition-all duration-300 mb-10" data-id="element-76">
            COMPRAR AHORA A $14.990 ARS
            <ArrowRight className="w-6 h-6" data-id="element-77" />
          </a>

          {/* Scarcity Box */}
          <div className="max-w-[500px] mx-auto border-2 border-[#ff006e] bg-[#ff006e]/10 p-5 rounded-xl animate-pulse-magenta mb-8" data-id="element-78">
            <p className="text-[#ff006e] font-bold text-lg mb-3" data-id="element-79">
              🔥 SÓLO QUEDAN 28 ESPACIOS A ESTE PRECIO
            </p>
            <div className="w-full h-2 bg-[#00d4ff]/10 rounded-full overflow-hidden" data-id="element-80">
              <div className="h-full bg-gradient-cyan-magenta w-[72%] rounded-full" data-id="element-81"></div>
            </div>
          </div>

          {/* Footer Hero */}
          <p className="text-[#888] text-sm font-medium" data-id="element-82">
            Acceso instantáneo. Garantía 30 días o dinero de vuelta. Sin
            preguntas.
          </p>
        </div>
      </div>
    </section>;
}